import React from "react";

export default function NotesFilters({
  patientId,
  templateId,
  onChangePatientId,
  onChangeTemplateId,
  onSearch,
  loading,
}) {
  return (
    <div className="cnl-filters">
      <div className="field">
        <label>Patient ID</label>
        <input
          value={patientId}
          onChange={(e) => onChangePatientId(e.target.value)}
          placeholder="Ej. 129807"
        />
      </div>
      <div className="field">
        <label>Template ID (opcional)</label>
        <input
          value={templateId}
          onChange={(e) => onChangeTemplateId(e.target.value)}
          placeholder="Ej. 100056147"
        />
      </div>
      <button className="btn primary" onClick={onSearch} disabled={loading}>
        {loading ? "Buscando..." : "Buscar"}
      </button>
    </div>
  );
}
